import { AccessibleStatus, AccessibleWarningStatus, AnimatedProgressIndicator, ArrowHigher, ArrowLower, ArrowSignificantlyHigher, ArrowSignificantlyLower, CanceledStatus, CancelingStatus, ClusteredStatus, CompleteMarkedStatus, CompleteStatus, CompleteWithWarningsStatus, ConditionalCompleteStatus, ConditionalStatus, DebuggerChangeIndicator, DebugStatus, DefaultStatus, DisconnectedStatus, EmbeddedStatus, ErrorStatus, FavoritedIndicator, FlaggedStatus, HiddenStatus, HistoricalStatus, ImportantStatus, IncompleteInProgressStatus, IncompleteMarkedStatus, IncompleteStatus, IncompleteWarningStatus, InformationMarkedStatus, InformationStatus, InsightFoundStatus, InsightStatus, InvalidMarkedStatus, InvalidStatus, LockedStatus, LowPriorityStatus, MediumPriorityStatus, MergedStatus, NeutralStatus, NewStatus, OnDemandStatus, OutOfSyncStatus, PausedStatus, PausedWithErrorsStatus, ProgressStatus, ReadOnlyStatus, RequiredStatus, RevertedStatus, ReviewStatus, ReviewWithWarningsStatus, ScheduledStatus, SentimentLevelNegative, SentimentLevelNeutral, SentimentLevelPositive, Shortcut, StoppedStatus, StoppingStatus, SubmittedStatus, SubmittedWithErrorsStatus, TimedOutStatus, TrendDownStatus, TrendNoChangeStatus, TrendUpStatus, VisibleStatus, WarningStatus } from '@sas/react-svg';
export const getIconAndLabelTextFromType = (type, localize) => {
  switch (type) {
    case 'Higher':
      return {
        icon: ArrowHigher,
        labelText: localize('predefined.higher.label')
      };
    case 'Lower':
      return {
        icon: ArrowLower,
        labelText: localize('predefined.lower.label')
      };
    case 'SignificantlyHigher':
      return {
        icon: ArrowSignificantlyHigher,
        labelText: localize('predefined.significantlyHigher.label')
      };
    case 'SignificantlyLower':
      return {
        icon: ArrowSignificantlyLower,
        labelText: localize('predefined.significantlyLower.label')
      };
    case 'Canceled':
      return {
        icon: CanceledStatus,
        labelText: localize('predefined.canceled.label')
      };
    case 'Clustered':
      return {
        icon: ClusteredStatus,
        labelText: localize('predefined.clustered.label')
      };
    case 'Completed':
      return {
        icon: CompleteStatus,
        labelText: localize('predefined.completed.label')
      };
    case 'CompletedWithWarnings':
      return {
        icon: CompleteWithWarningsStatus,
        labelText: localize('predefined.completedWithWarnings.label')
      };
    case 'Debug':
      return {
        icon: DebugStatus,
        labelText: localize('predefined.debug.label')
      };
    case 'Embedded':
      return {
        icon: EmbeddedStatus,
        labelText: localize('predefined.embedded.label')
      };
    case 'Error':
      return {
        icon: ErrorStatus,
        labelText: localize('predefined.error.label')
      };
    case 'Flagged':
      return {
        icon: FlaggedStatus,
        labelText: localize('predefined.flagged.label')
      };
    case 'Important':
      return {
        icon: ImportantStatus,
        labelText: localize('predefined.important.label')
      };
    case 'IncompleteProgress':
      return {
        icon: IncompleteInProgressStatus,
        labelText: localize('predefined.incompleteProgress.label')
      };
    case 'Incomplete':
      return {
        icon: IncompleteStatus,
        labelText: localize('predefined.incomplete.label')
      };
    case 'Information':
      return {
        icon: InformationStatus,
        labelText: localize('predefined.information.label')
      };
    case 'Invalid':
      return {
        icon: InvalidStatus,
        labelText: localize('predefined.invalid.label')
      };
    case 'Locked':
      return {
        icon: LockedStatus,
        labelText: localize('predefined.locked.label')
      };
    case 'Low':
      return {
        icon: LowPriorityStatus,
        labelText: localize('predefined.low.label')
      };
    case 'Medium':
      return {
        icon: MediumPriorityStatus,
        labelText: localize('predefined.medium.label')
      };
    case 'Neutral':
      return {
        icon: NeutralStatus,
        labelText: localize('predefined.neutral.label')
      };
    case 'New':
      return {
        icon: NewStatus,
        labelText: localize('predefined.new.label')
      };
    case 'OnDemand':
      return {
        icon: OnDemandStatus,
        labelText: localize('predefined.onDemand.label')
      };
    case 'Paused':
      return {
        icon: PausedStatus,
        labelText: localize('predefined.paused.label')
      };
    case 'InProgress':
      return {
        icon: ProgressStatus,
        labelText: localize('predefined.inProgress.label')
      };
    case 'Reverted':
      return {
        icon: RevertedStatus,
        labelText: localize('predefined.reverted.label')
      };
    case 'InReview':
      return {
        icon: ReviewStatus,
        labelText: localize('predefined.inReview.label')
      };
    case 'Scheduled':
      return {
        icon: ScheduledStatus,
        labelText: localize('predefined.scheduled.label')
      };
    case 'NegativeSentimentalLevel':
      return {
        icon: SentimentLevelNegative,
        labelText: localize('predefined.negativeSentimentalLevel.label')
      };
    case 'NeutralSentimentalLevel':
      return {
        icon: SentimentLevelNeutral,
        labelText: localize('predefined.neutralSentimentalLevel.label')
      };
    case 'PositiveSentimentalLevel':
      return {
        icon: SentimentLevelPositive,
        labelText: localize('predefined.positiveSentimentalLevel.label')
      };
    case 'Stopped':
      return {
        icon: StoppedStatus,
        labelText: localize('predefined.stopped.label')
      };
    case 'Stopping':
      return {
        icon: StoppingStatus,
        labelText: localize('predefined.stopping.label')
      };
    case 'Submitted':
      return {
        icon: SubmittedStatus,
        labelText: localize('predefined.submitted.label')
      };
    case 'Warning':
      return {
        icon: WarningStatus,
        labelText: localize('predefined.warning.label')
      };
    case 'AnimatedInProgress':
      return {
        icon: AnimatedProgressIndicator,
        labelText: localize('predefined.animatedInProgress.label')
      };
    case 'OutOfSync':
      return {
        icon: OutOfSyncStatus,
        labelText: localize('predefined.outOfSync.label')
      };
    case 'ConditionalGrant':
      return {
        icon: ConditionalCompleteStatus,
        labelText: localize('predefined.conditionalGrant.label')
      };
    case 'Visible':
      return {
        icon: VisibleStatus,
        labelText: localize('predefined.visible.label')
      };
    case 'Hidden':
      return {
        icon: HiddenStatus,
        labelText: localize('predefined.hidden.label')
      };
    case 'Merged':
      return {
        icon: MergedStatus,
        labelText: localize('predefined.merged.label')
      };
    case 'Favorite':
      return {
        icon: FavoritedIndicator,
        labelText: localize('predefined.favorite.label')
      };
    case 'Shortcut':
      return {
        icon: Shortcut,
        labelText: localize('predefined.shortcut.label')
      };
    case 'TrendDownStatus':
      return {
        icon: TrendDownStatus,
        labelText: localize('predefined.trendDown.label')
      };
    case 'TrendNoChangeStatus':
      return {
        icon: TrendNoChangeStatus,
        labelText: localize('predefined.trendNoChange.label')
      };
    case 'TrendUpStatus':
      return {
        icon: TrendUpStatus,
        labelText: localize('predefined.trendUp.label')
      };
    case 'Accessible':
      return {
        icon: AccessibleStatus,
        labelText: localize('predefined.accessible.label')
      };
    case 'AccessibleWarning':
      return {
        icon: AccessibleWarningStatus,
        labelText: localize('predefined.accessibleWarning.label')
      };
    case 'Conditional':
      return {
        icon: ConditionalStatus,
        labelText: localize('predefined.conditional.label')
      };
    case 'DebuggerChangeIndicator':
      return {
        icon: DebuggerChangeIndicator,
        labelText: localize('predefined.debuggerChangeIndicator.label')
      };
    case 'Disconnected':
      return {
        icon: DisconnectedStatus,
        labelText: localize('predefined.disconnected.label')
      };
    case 'IncompleteWarning':
      return {
        icon: IncompleteWarningStatus,
        labelText: localize('predefined.incompleteWarning.label')
      };
    case 'InsightFound':
      return {
        icon: InsightFoundStatus,
        labelText: localize('predefined.insightFound.label')
      };
    case 'Insight':
      return {
        icon: InsightStatus,
        labelText: localize('predefined.insight.label')
      };
    case 'ReadOnly':
      return {
        icon: ReadOnlyStatus,
        labelText: localize('predefined.readOnly.label')
      };
    case 'Required':
      return {
        icon: RequiredStatus,
        labelText: localize('predefined.required.label')
      };
    case 'Historical':
      return {
        icon: HistoricalStatus,
        labelText: localize('predefined.historical.label')
      };
    case 'Canceling':
      return {
        icon: CancelingStatus,
        labelText: localize('predefined.canceling.label')
      };
    case 'Default':
      return {
        icon: DefaultStatus,
        labelText: localize('predefined.default.label')
      };
    case 'ReviewWithWarnings':
      return {
        icon: ReviewWithWarningsStatus,
        labelText: localize('predefined.reviewWithWarnings.label')
      };
    case 'CompleteMarked':
      return {
        icon: CompleteMarkedStatus,
        labelText: localize('predefined.completeMarked.label')
      };
    case 'IncompleteMarked':
      return {
        icon: IncompleteMarkedStatus,
        labelText: localize('predefined.incompleteMarked.label')
      };
    case 'InformationMarked':
      return {
        icon: InformationMarkedStatus,
        labelText: localize('predefined.informationMarked.label')
      };
    case 'InvalidMarked':
      return {
        icon: InvalidMarkedStatus,
        labelText: localize('predefined.invalidMarked.label')
      };
    case 'PausedWithErrors':
      return {
        icon: PausedWithErrorsStatus,
        labelText: localize('predefined.pausedWithErrors.label')
      };
    case 'SubmittedWithErrors':
      return {
        icon: SubmittedWithErrorsStatus,
        labelText: localize('predefined.submittedWithErrors.label')
      };
    case 'TimedOut':
      return {
        icon: TimedOutStatus,
        labelText: localize('predefined.timedOut.label')
      };
  }
};
//# sourceMappingURL=getIconAndLabelTextFromType.js.map